module.exports = "<div id=\"<%- data.userId %>\" class=\"link-user\">\r\n\t<div class=\"user-image\"\r\n\t\tstyle=\"background-image:url(<%-data.photoURL%>)\">\r\n\t</div>\r\n\t<div>\r\n\t\t<p><%- data.displayName %></p>\r\n\t\t<p><%- data.email %></p>\r\n\t</div>\r\n\t<div class=\"clearfix\"></div>\r\n\t<button class=\"btn btn-sm btn-primary btn-link-user\">\r\n\t\tLink with this user\r\n\t</button>\r\n\t<div class=\"alert alert-success hidden\">\r\n\t\t<strong>Linked!</strong>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/players/_modals/link-player-modal/link-user/link-user.tpl.html
// module id = 71
// module chunks = 0